import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';
import { ICart, ICartMenus } from 'interfaces/cart';
import { IYogiyoStore } from 'interfaces/store';

export type TCartInitialState = Partial<ICart & { error: string | null }>;

const initialState: TCartInitialState = {
  store: undefined,
  menus: [],
  user: undefined,
  _id: undefined,
  error: null,
};

export const cartSelector = (state: RootState) => state.cart;

export const popupSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setInitCart: (state, action) => {
      state = action.payload;
      return state;
    },
    setRestaurant: (state, action) => {
      state = action.payload;
      return state;
    },
    setCartMenu: (state, action) => {
      const {
        restaurant,
        menu,
      }: { restaurant: IYogiyoStore; menu: ICartMenus } = action.payload;

      let menuResult: ICartMenus[] = [];
      const { menus } = state;

      const exist = menus?.find((_menu) => _menu.id === menu.id);

      if (!state.store || state.store.id !== restaurant.id) {
        state.store = restaurant;
        menuResult = [menu];
      } else if (!menus || menus.length === 0) {
        menuResult = [menu];
      } else if (!exist) {
        menuResult = [...menus, menu];
      } else if (
        !exist.options.every((_option) =>
          menu.options.some((targetOption) => targetOption.id === _option.id),
        )
      ) {
        menuResult = [...menus, menu];
      } else {
        menuResult = menus.map((item) =>
          item.id === menu.id
            ? { ...item, quantity: item.quantity + menu.quantity }
            : item,
        );
      }

      localStorage.setItem(
        'cart',
        JSON.stringify({
          store: restaurant,
          menus: menuResult,
          updatedAt: new Date(),
        }),
      );
      state.menus = menuResult;
      return state;
    },
    deleteMenu: (state, action) => {
      const menuId = action.payload;
      const { menus } = state;

      const filtered = menus?.filter((menu) => menu.id !== menuId);

      state.menus = filtered;
      localStorage.setItem(
        'cart',
        JSON.stringify({ store: state.store, menus: filtered }),
      );
      return state;
    },
    controlMenuQuantity: (state, action) => {
      const { id, quantity }: { id: number; quantity: number } = action.payload;

      const { menus } = state;

      const _menus = menus?.map((menu) =>
        menu.id === id ? { ...menu, quantity } : menu,
      );
      state.menus = _menus;
      localStorage.setItem(
        'cart',
        JSON.stringify({
          store: state.store,
          menus: _menus,
          updatedAt: new Date(),
        }),
      );
      return state;
    },
    initCart: (state, _) => {
      localStorage.setItem(
        'cart',
        JSON.stringify({ store: undefined, menus: [] }),
      );
      state.store = undefined;
      state.menus = [];
      state.error = '';
      return state;
    },
  },
});

export const {
  setInitCart,
  setRestaurant,
  setCartMenu,
  deleteMenu,
  controlMenuQuantity,
  initCart,
} = popupSlice.actions;

export default popupSlice.reducer;
